export enum FAQ_TYPE {
    Market = "MARKET",
    Default = "DEFAULT",
}